/* tslint:disable */
/* eslint-disable */
/**
 * BusService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { ReserveSeatParams } from '../model';
// @ts-ignore
import { ReserveSeatParamsV2Dto } from '../model';
// @ts-ignore
import { ReserveSeatResultDto } from '../model';
/**
 * ReserveSeatApiApiReserveSeatPost - axios parameter creator
 * 
 * @param {ReserveSeatParams} [reserveSeatParams] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveSeatApiApiReserveSeatPostAxiosParamCreator (reserveSeatParams?: ReserveSeatParams, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/ReserveSeat`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(reserveSeatParams, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveSeatApiApiReserveSeatV2Post - axios parameter creator
 * 
 * @param {ReserveSeatParamsV2Dto} [reserveSeatParamsV2Dto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveSeatApiApiReserveSeatV2PostAxiosParamCreator (reserveSeatParamsV2Dto?: ReserveSeatParamsV2Dto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/ReserveSeat/v2`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(reserveSeatParamsV2Dto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiReserveSeatPost operation in ReserveSeatApi.
 * @export
 * @interface ReserveSeatApiApiReserveSeatPostRequest
 */
export interface ReserveSeatApiApiReserveSeatPostRequest {
    /**
     * 
     * @type {ReserveSeatParams}
     * @memberof ReserveSeatApiApiReserveSeatPost
     */
    readonly reserveSeatParams?: ReserveSeatParams
}

/**
 * Request parameters for apiReserveSeatV2Post operation in ReserveSeatApi.
 * @export
 * @interface ReserveSeatApiApiReserveSeatV2PostRequest
 */
export interface ReserveSeatApiApiReserveSeatV2PostRequest {
    /**
     * 
     * @type {ReserveSeatParamsV2Dto}
     * @memberof ReserveSeatApiApiReserveSeatV2Post
     */
    readonly reserveSeatParamsV2Dto?: ReserveSeatParamsV2Dto
}

/**
* 
* @param {ReserveSeatApiApiReserveSeatPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveSeatApiApiReserveSeatPost(requestParameters: ReserveSeatApiApiReserveSeatPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveSeatApiApiReserveSeatPostAxiosParamCreator(requestParameters.reserveSeatParams, options, configuration);
    const request: () => AxiosPromise<ReserveSeatResultDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveSeatApiApiReserveSeatV2PostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveSeatApiApiReserveSeatV2Post(requestParameters: ReserveSeatApiApiReserveSeatV2PostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveSeatApiApiReserveSeatV2PostAxiosParamCreator(requestParameters.reserveSeatParamsV2Dto, options, configuration);
    const request: () => AxiosPromise<ReserveSeatResultDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
